import SeatMapCard from './SeatMapCard';

export default SeatMapCard;
